import React from 'react';
import MediaQuery, { useMediaQuery } from 'react-responsive';
import ActionHeader from '../../../components/actionHeader';
import { OutlineButtonSelect } from '../../../components/input';
import { OutlineButtonIcon, SecondaryButton } from '../../../components/buttons';
import ArrowDownRedIcon from '../../../assets/icons/arrow-down-red.svg';
import RefreshIcon from '../../../assets/icons/refresh.svg';
import { mobileBreakpoint } from '../../../lib';

const speedOptions = [
    {value: 2500, label: 'Slow'},
    {value: 1000, label: 'Normal'},
    {value: 500,  label: 'Fast'},
];

function Header({ heading, subHeading, speed, setDraftSpeed, openRestartModal, openExitModal, sponsorLogo }){
    const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    return (
        <ActionHeader 
            heading={heading}
            subHeading={subHeading}
            handleOpenExitModal={openExitModal}
            sponsorLogo={sponsorLogo}
        >
            <OutlineButtonSelect
                margin={isMobile ? '0' : '0 30px 0 0'}
                label="Draft Speed"
                selectId="select-speed"
                options={speedOptions}
                icon={ArrowDownRedIcon}
                value={speed}
                onChange={(value) => setDraftSpeed(value)} />
            <OutlineButtonIcon
                margin={isMobile ? '0' : '0 40px 0 0'}
                icon={RefreshIcon}
                onClick={openRestartModal}
            >
                    Restart
            </OutlineButtonIcon>
            <MediaQuery minWidth={901}>
                <SecondaryButton
                    padding="10px 20px"
                    onClick={openExitModal}
                >
                        Exit Draft
                </SecondaryButton>
            </MediaQuery>
        </ActionHeader>
    );
}

export default Header;